import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { AccountRoutesType } from "../../navigationUtils";
import { MyMealsNavDrawerMenuTrigger } from "../NavDrawerComponents/MyMealsNavDrawerMenuTrigger";
import { MyMealsNavBarMenuTrigger } from "../NavBarComponents/MyMealsNavBarMenuTrigger";
export const MyMealsMenuTrigger = ({ M, isNavDrawer, displayText }) => {
    const theme = useTheme();
    const selectedColor = theme.palette.common.black;
    const unSelectedColor = theme.palette.grey[`A700`];
    const selectionColor = location.pathname === AccountRoutesType.MY_MEALS ? selectedColor : unSelectedColor;
    return isNavDrawer ? (_jsx(MyMealsNavDrawerMenuTrigger, { selectionColor: selectionColor, isMyMealsNavDrawerMenuOpen: M.isMyMealsNavDrawerMenuOpen, setIsMyMealsNavDrawerMenuOpen: M.setIsMyMealsNavDrawerMenuOpen, displayText: displayText })) : (_jsx(MyMealsNavBarMenuTrigger, { handleClick: M.handleClick, open: M.open, menuStyles: M.menuStyles, displayText: displayText }));
};
